import { Colors } from "./Colors";

export var commons = {
    Colors,
};